// extracted by mini-css-extract-plugin
export const backButton = "back-button-module--backButton--g5aBx";